import React from 'react';

import s from './emptyCartHeader.scss';

type PropsType = {
    title: string;
};

/**
 * Component for empty cart header
 * @returns {React.ReactElement} Rendered react component
 */
export const EmptyCartHeader: React.FC<PropsType> = ({title}) => {
    return (
        <div className={s.titleWrapper}>
            <h3 className={s.title}>{title}</h3>
        </div>
    );
};
